import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['secondLunch', 'startTime', 'endTime']
  static values  = { friday: Boolean }

  connect() {
    this.toggleSecondLunch()
  }

  toggleSecondLunch() {
    if (!this.hasSecondLunchTarget) return

    const allowed = this.isSecondLunchAllowed()
    this.secondLunchTarget.style.display = allowed ? 'block' : 'none'

    if (!allowed) {
      const select = this.secondLunchTarget.querySelector('select')
      if (select) select.value = ''
    }
  }

  isSecondLunchAllowed() {
    if (!this.fridayValue) return false

    const startTime = this.parseTime(this.startTimeTarget.value)
    const endTime   = this.parseTime(this.endTimeTarget.value)

    if (!startTime || !endTime) return false

    return startTime.hours < 12 && endTime.hours >= 18
  }

  parseTime(timeString) {
    if (!timeString) return null

    const match = timeString.match(/^(\d{1,2}):(\d{2})$/)
    if (!match) return null

    return {
      hours:   parseInt(match[1], 10),
      minutes: parseInt(match[2], 10)
    }
  }
}
